const randomId = () => (Math.random() + 1).toString(36).substring(7);
export {
  randomId
};
//# sourceMappingURL=randomId.js.map
